/**
 * @description Manage Storage Policies
 */
class StorageBackendService {
    /**
     * @description Service base URL (without trailing `/`)
     */
    public static base_url: string = import.meta.env.VITE_APP_STORAGE_BACKEND_SERVICE_URL
    public static axios: any

    public static init (axiosInstance: any) {
      StorageBackendService.axios = axiosInstance
    }

    public static list_s3_backends(with_distance: boolean = false, with_pricing: boolean = false, with_carbon_intensity: boolean = false) {
      const url_params = {
        'with_distance': Number(with_distance),
        'with_pricing': Number(with_pricing),
        'with_carbon_intensity_details': Number(with_carbon_intensity)
      }
      return StorageBackendService.axios.get(StorageBackendService.base_url + '/backends', { params: url_params })
    }

    public static list_cloud_providers() {
      return StorageBackendService.axios.get(StorageBackendService.base_url + "/providers")
    }

    public static get_team_buckets() {
      return StorageBackendService.axios.get(StorageBackendService.base_url + "/buckets")
    }
}

export default StorageBackendService
